import React from "react";
import './use-case-features.css'

// ...... images .......
import interactive from '../../../../assets/images/intractive-purple.svg';
import insert from '../../../../assets/images/insert-call.svg';
import embed from '../../../../assets/images/embed-enywhere.svg';
import code from '../../../../assets/images/no-code.svg';

function UseCaseFeatures() {
   return(
       <div className="content-box width-1000">
          <div className="title-font">Top Features</div>
          <ul className="features-list col-2">
             <li>
                <div className="icon feature-icon">
                   <img src={interactive} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Custom Branding</div>
                <div className="feature-desc">
                   Add custom company logo and brand colors to the videos and collateral you create.
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={insert} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Effortless Integration</div>
                <div className="feature-desc">
                   Integrates easily with most tools, wikis and knowledge bases
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={embed} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Browser extension</div>
                <div className="feature-desc">
                   Works on any web product or web-based workflow
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={code} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Interactive</div>
                <div className="feature-desc">
                   Your viewers can annotate and leave a comment anywhere on the vide
                </div>
             </li>
          </ul>
       </div>
   )
}

export default UseCaseFeatures
